import { GetApiData } from './fetchConfig';

export const usePersonRoleTypes = () => GetApiData('persons/role-types');
